<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :defaultParams="defaultParams">
      <template #packageType="row">
        {{ packageTypes[row.data.monthCardPlanBean && row.data.monthCardPlanBean.durationType] }}
      </template>
      <template #packageName="row">
        {{ row.data.monthCardPlanBean && row.data.monthCardPlanBean.planName }}
      </template>
      <template #orderTime="row">
        {{ row.data.orderTime | timeFormate }}
      </template>
      <template #registerTime="row">
        <div v-if="row.data.registerTime">{{ row.data.registerTime | timeFormate }}</div>
      </template>
      <template #overdueTime="row">
        {{ row.data.overdueTime | timeFormate }}
      </template>
      <template #cardOrderStatus="row">
        {{ packageCardOrderStatus[row.data.cardOrderStatus] }}
      </template>
      <template #cardStatus="row">
        {{ packageCardStatus[row.data.cardStatus] }}
      </template>
      <template #operation="row">
        <template v-if="!typeOfView">
          <el-button type="primary" size="mini" @click="handleDetail(row.data)">详情</el-button>
          <el-button
            v-if="!typeOfView && row.data.cardOrderStatus === 1"
            type="warning"
            size="mini"
            @click="handleRefund(row.data)"
            >退款</el-button
          >
        </template>
      </template>
      <template #endReason="row">
        {{ row.data.errorReason }}
      </template>
      <template #refundStatus="row">
        {{ refundStatusMap[row.data.refundStatus] || '' }}
      </template>
    </com-table>
    <com-dialog :visible.sync="dialogVisible" title="退款" width="40%">
      <div>
        <div>
          <span>订单 {{ chargeBackData.number }}</span>
          <span class="ml-15px"> 订单金额 {{chargeBackData.money }} </span>
        </div>
        <div class="flex items-center mt-15px">
          <div>退款金额：</div>
          <el-input
            style="width: 300px;"
            placeholder="请输入退款金额"
            v-model="refundSum"
          ></el-input>
        </div>
        <div class="flex items-center mt-15px">
          <div>退款原因：</div>
          <el-input
            style="width: 300px;"
            placeholder="请输入退款原因"
            v-model="refundReason"
          ></el-input>
        </div>
        <div class="mt-15px flex items-center justify-end">
          <el-button type="" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleRefundApply">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { packageOrderListApi, packageCardRefundApi } from '@/api/package-order'
import { partnerPackageOrderList } from '@/api/partners'
import { packageTypes, packageCardStatus, packageCardOrderStatus } from '@/json/common'
import utils from 'my-tools-library'
import comCheckedPwd from '../passWord/com-checked-pwd'

export default {
  components: { comCheckedPwd },
  props: {
    defaultParams: {
      type: Object,
      default: () => {}
    },
    typeOfView: {
      type: String,
      default: ''
    },
    userCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    typeOfView: {
      handler(val) {
        if (val) {
          if (val === 'partner') {
            this.columns.find(item => item.prop === 'orderDivide').hidden = false
            // 合伙人套餐订单隐藏部分数据
            this.columns.find(item => item.prop === 'cardOrderStatus').hidden = true
            this.columns.find(item => item.prop === 'registerTime').hidden = true
            this.columns.find(item => item.prop === 'totalTimeStr').hidden = true
            this.columns.find(item => item.prop === 'surplusTimeStr').hidden = true
            this.columns.find(item => item.prop === 'usedTimeStr').hidden = true
            this.columns.find(item => item.prop === 'overdueTime').hidden = true
            this.columns.find(item => item.prop === 'cardStatus').hidden = true
            this.api = partnerPackageOrderList
          }
          this.columns.splice(-1, 1)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      api: packageOrderListApi,
      packageTypes,
      packageCardOrderStatus,
      packageCardStatus,


      refundStatusMap: {
        0: '退款中',
        1: '退款成功',
        2: '退款失败'
      },

      columns: [
        {
          label: '订单编号',
          prop: 'number',
          minWidth: '180'
        },
        {
          label: '套餐卡名称',
          prop: 'packageCardName',
          minWidth: '180'
        },
        {
          label: '套餐名称',
          type: 'slot',
          prop: '',
          slotName: 'packageName',
          minWidth: '180'
        },
        {
          label: '套餐类型',
          prop: 'packageType',
          type: 'slot',
          slotName: 'packageType',
          minWidth: '100'
        },
        {
          label: '订单金额',
          prop: 'money',
          minWidth: '100'
        },
        {
          label: '支付金额',
          prop: 'paySum',
          minWidth: '100'
        },
        {
          label: '订单分成',
          prop: 'orderDivide',
          minWidth: '150',
          hidden: true
        },
        {
          label: '用户ID',
          prop: 'userNumber',
          width: '150'
        },
        {
          label: '手机号',
          prop: 'phone',
          minWidth: '150'
        },
        {
          label: '下单时间',
          prop: 'orderTime',
          type: 'slot',
          slotName: 'orderTime',
          minWidth: '120'
        },
        {
          label: '订单状态',
          prop: 'cardOrderStatus',
          type: 'slot',
          slotName: 'cardOrderStatus',
          minWidth: '120',
          hidden: false
        },
        {
          label: '开通时间',
          prop: 'registerTime',
          type: 'slot',
          slotName: 'registerTime',
          minWidth: '120',
          hidden: false
        },
        {
          label: '套餐时长',
          prop: 'totalTimeStr',
          minWidth: '120',
          hidden: false
        },
        {
          label: '剩余时长',
          prop: 'surplusTimeStr',
          minWidth: '120',
          hidden: false
        },
        {
          label: '已用时长',
          prop: 'usedTimeStr',
          minWidth: '120',
          hidden: false
        },
        {
          label: '有效期至',
          prop: 'overdueTime',
          type: 'slot',
          slotName: 'overdueTime',
          minWidth: '120',
          hidden: false
        },
        {
          label: '套餐卡状态',
          prop: 'cardStatus',
          type: 'slot',
          slotName: 'cardStatus',
          minWidth: '150',
          hidden: false
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          minWidth: '180'
        }
      ],
      dialogVisible: false,
      chargeBackData: {},
      refundSum: '',
      refundReason: ''
    }
  },
  methods: {
    init() {
      this.$refs.tableRef.init()
    },
    search(val) {
      this.$refs.tableRef.search(val)
    },
    handleDetail(val) {
      this.$router.push({ path: 'pacakage-card-order-detail', query: { code: val.code } })
    },
    handleRefund(row) {
      this.refundSum = ''
      this.refundReason = ''
      this.chargeBackData = utils.deepCopy(row)
      this.dialogVisible = true
      console.log('退款 :>> ', this.chargeBackData)
    },
    // 退款申请
    handleRefundApply() {
      if (this.refundSum > this.chargeBackData.money) return this.$message.error('退款金额不能大于订单金额')
      const params = {
        monthCardOrderCode: this.chargeBackData.code,
        refundPrice: this.refundSum,
        reason: this.refundReason
      }
      packageCardRefundApi(params).then(res => {
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.init()
      })
    },
  }
}
</script>
